module.exports = __webpack_public_path__ + "img/dosing.eab9b6af.png";